module.exports = __webpack_public_path__ + "img/vk.82df79be.svg";